<template>
  <div class="maincontainer">
    <table>
    <thead>
      <tr>
        <th style="min-width: 30ch;" v-on:click="set_order('created_at')">
          <span>{{$t('protocols.date_added')}}</span>
          <i class="material-icons dp6" v-if="orderby == 'created_at' && order == 'desc'">arrow_drop_down</i> 
          <i class="material-icons dp6" v-if="orderby == 'created_at' && order == 'asc'">arrow_drop_up</i>
        </th>
        <th style="min-width: 30ch;">
            <div v-on:click="set_order('date')">
              <span>{{$t('protocols.date')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
            </div>
            <select v-model="rangeSelected">
              <option value="currentMonth">{{$t('calendar.current_month')}}</option>
              <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
               <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                <option value="currentYear">{{$t('calendar.current_year')}}</option>
                <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                <option value="other">{{$t('calendar.other_range')}}</option>
            </select>
            <div class="row" v-if="rangeSelected == 'other'">
              <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                <input type="date" v-model="fromSelected"/>
                <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
              </div>
              <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                <input type="date" v-model="toSelected"/>
                <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
              </div>
            </div>
        </th>
        <th v-on:click="set_order('worker_name')">
          <span>{{$t('protocols.where')}}</span>
        </th>
        <th>
          <span>{{$t('protocols.name')}}</span>
        </th>
        <th v-on:click="set_order('place_name')">
          <span>{{$t('protocols.attachment')}}</span>
        </th>
        <th></th>
      </tr>
    </thead>

    <tbody v-if="loaded">
      <template  v-for="(intervention, index) in listItems">
      <tr>
        <td>{{intervention.created_at | formatDate}}</td>
        <td>{{intervention.date | formatDate}}</td>
        <td>{{intervention.place_name}}</td>
        <td>{{intervention.name}}</td>
        <td><a :href='intervention.url'><i class="material-icons dp6">list_alt</i></a></td>
      </tr>
     
      </template>
    </tbody>
    <preloader v-if="loaded == false" n="7"/>
  </table>
  <template v-if="listItems.length == 0 && loaded"><p style="font-size: 12px;">{{$t('protocols.no_protocol')}}</p></template>
</div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
export default {
  data: function () {
    return {
      order: 'desc',
      orderby: 'number',
      interventions: [],
      workerItems: [],
      selected_kinds: [],
      rangeSelected: "currentMonth",
      lastRange: "currentMonth",
      from: moment().startOf("month").format("YYYY-MM-DD"),
      to: moment().endOf("month").format("YYYY-MM-DD"),
      fromSelected: moment().startOf("month").format("YYYY-MM-DD"),
      toSelected: moment().endOf("month").format("YYYY-MM-DD"),
      loaded: false,
      kinds: [
        {name: this.$t('interventions.deratization'), value: "deratization"},
        {name: this.$t('interventions.disinsection'), value: "disinsection"},
        {name: this.$t('interventions.disinfection'), value: "disinfection"},
        {name: this.$t('interventions.other'), value: "other"}
      ],
      addrsearch: "",
      customersearch: "",
      idsearch: "",
      pricesearch: ""
    }
  },
  watch: {
    rangeSelected: function (val) {
      if(val == "currentMonth"){
        this.lastRange = val;
        this.from = moment().startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "prevMonth"){
        this.lastRange = val;
        this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
      }else if(val == "lastThreeMonths"){
        this.lastRange = val;
        this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "currentYear"){
        this.lastRange = val;
        this.from = moment().startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("year").format("YYYY-MM-DD")
        this.to = moment().endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("year").format("YYYY-MM-DD")
      }else if(val == "prevYear"){
        this.lastRange = val;
        this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
      }
      this.fetch_interventions(moment(this.from), moment(this.to));
    },
  },
  created() {
    var that = this;
    axios.get('/interventions/last.json').then(response => {
      if(response.data != null){
        var last_time = moment(response.data * 1000);
        if(last_time.isBetween(moment().startOf("month"), moment().endOf("month"))) that.rangeSelected = "currentMonth";
        else if(last_time.isBetween(moment().subtract(1,'months').startOf("month"), moment().subtract(1,'months').endOf("month"))) that.rangeSelected = "prevMonth";
        else if(last_time.isBetween(moment().subtract(3,'months').startOf("month"), moment().endOf("month"))) that.rangeSelected = "lastThreeMonths";
        else if(last_time.isBetween(moment().startOf("year"), moment().endOf("year"))) that.rangeSelected = "currentYear";
        else if(last_time.isBetween(moment().subtract(1,'years').startOf("year"), moment().subtract(1,'years').endOf("year")))
          that.rangeSelected = "prevYear";
        else{
          that.from = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.fromSelected = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.to = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.toSelected = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.rangeSelected = "other";
        }
        that.fetch_interventions(moment(that.from), moment(that.to));
      }
    });
    
  },
  methods: {
    fetch_interventions: function(a, b){
      this.loaded = false;
      axios.get('/protocols.json').then(response => {
        this.interventions = response.data;
        this.loaded = true;
        for(var i in this.interventions){
          var item = this.interventions[i];
        }
      })
    },
    collapse : function(customer){
      customer.collapsed = !(customer.collapsed);
      this.$forceUpdate();
    },
    cancelChanges: function(){
      this.rangeSelected = this.lastRange;
    },
    applyChanges: function(){
      this.from = this.fromSelected;
      this.to = this.toSelected;
    },
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 'desc'){
          this.order = 'asc'
        }else if(this.order == 'asc'){
          this.order = 'desc'
        }
        
      }else{
        this.orderby = order;
      }
    }
},
computed: {
    listItems() {
      var that = this;
      return  _.orderBy(this.interventions, this.orderby, this.order);
    },
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
.login_button{
  color: red;
}
p {
  font-size: 2em;
  text-align: center;
}
thead{
  background-color: #DADADA;

}
thead th{
  font-weight: 300;
  padding-top: 5px;
  padding-bottom: 5px;
  vertical-align: baseline;
}
th span{
  padding-left: 5px !important;
}
td{
  padding-left: 15px !important;
}
thead .input-field{
  margin-top: unset;
  margin-bottom: unset;
}
.maincontainer{
  padding-top: 10px;
  margin-top: 10px;
  margin-right: 33px;
  margin-bottom: 33px;
  margin-left: 33px;
}
a {
  color: black;
}
.btn-large{
  background-color: #c22026;
  color: black;
}
select {
  display: block;
  padding-top: 0px;
  padding-bottom: 0 0 0 0;
  height: 35px;
  border-radius: 4px !important;
  border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
</style>
